module.exports = __webpack_public_path__ + "static/media/manager_qrcode.58bf2acc.jpg";